import { render, staticRenderFns } from "./VMainBanner.vue?vue&type=template&id=6e0fd09d&"
import script from "./VMainBanner.vue?vue&type=script&lang=js&"
export * from "./VMainBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports